import { render, staticRenderFns } from "./ProjectBudgetsV4.vue?vue&type=template&id=1e6edcd3&scoped=true"
import script from "./ProjectBudgetsV4.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetsV4.vue?vue&type=script&lang=js"
import style0 from "./ProjectBudgetsV4.vue?vue&type=style&index=0&id=1e6edcd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6edcd3",
  null
  
)

export default component.exports